module.exports = __webpack_public_path__ + "img/subana.a12ee1ad.png";